// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-body .button-model {
  background: #ffffff !important;
  font-family: "Chakra Petch" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 18px !important;
  color: #444444 !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 16px 0px 16px 16px !important;
  width: -moz-fit-content;
  width: fit-content;
}

.button-body .text-spn {
  margin-right: 16px;
}
.button-body .btn-icon {
  width: 30px;
  height: auto;
  margin-left: 10px;
  margin-right: 10px;
}

.button-body .right {
  background: #d8ccfb;
  cursor: pointer;
}

.button-model:hover + .right {
  transition: 0.4s ease-in-out all;
  background: #4a19ed;
}

.button-body .btn-icon {
  width: 30px;
  height: auto;
  object-fit: contain;
  margin-top: 15px;
}

.button-body {
  width: -moz-fit-content;
  width: fit-content;
  padding: 4px;
  background: linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 0,
    linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 100%,
    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 0,
    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 100%,
    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 0 0,
    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 100% 0,
    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 0 100%,
    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 12px 12px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/components/buttonModel.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,sCAAsC;EACtC,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ;;;;;;;qEAOmE;EACnE,4BAA4B;EAC5B,0BAA0B;AAC5B","sourcesContent":[".button-body .button-model {\n  background: #ffffff !important;\n  font-family: \"Chakra Petch\" !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  font-size: 16px !important;\n  line-height: 18px !important;\n  color: #444444 !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 16px 0px 16px 16px !important;\n  width: fit-content;\n}\n\n.button-body .text-spn {\n  margin-right: 16px;\n}\n.button-body .btn-icon {\n  width: 30px;\n  height: auto;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.button-body .right {\n  background: #d8ccfb;\n  cursor: pointer;\n}\n\n.button-model:hover + .right {\n  transition: 0.4s ease-in-out all;\n  background: #4a19ed;\n}\n\n.button-body .btn-icon {\n  width: 30px;\n  height: auto;\n  object-fit: contain;\n  margin-top: 15px;\n}\n\n.button-body {\n  width: fit-content;\n  padding: 4px;\n  background: linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 0,\n    linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 100%,\n    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 0,\n    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 100%,\n    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 0 0,\n    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 100% 0,\n    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 0 100%,\n    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 100% 100%;\n  background-repeat: no-repeat;\n  background-size: 12px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
